import { InputNumber } from "primereact/inputnumber";
import { InputLabel } from "./InputLabel";

import { InputNumberValueChangeEvent } from "primereact/inputnumber";

interface NumberInputFieldProps {
  name: string;
  label: string;
  value: number | null | undefined;
  onChange: (e: InputNumberValueChangeEvent) => void;
  errorMessage?: string;
  containerClassName?: string;
  inputClassName?: string;
  required?: boolean;

  min?: number;
  max?: number;
  step?: number;

  minFractionDigits?: number;
  maxFractionDigits?: number;
  prefix?: string;
  suffix?: string;
  mode?: "decimal" | "currency";
  currency?: string;
  locale?: string;
  placeholder?: string;
  disabled?: boolean;

  showButtons?: boolean;
  buttonLayout?: "stacked" | "horizontal" | "vertical";
}

const NumberInputField = ({
  name,
  label,
  placeholder,
  disabled = false,
  required = false,
  value,
  onChange,
  errorMessage,
  containerClassName = "field col-12 md:col-6",
  inputClassName = "input-field",
  min,
  max,
  step = 1,
  minFractionDigits = 0,
  maxFractionDigits = 3,
  prefix = "",
  suffix = "",
  mode = "decimal", // "decimal" | "currency"
  currency = "EUR", // used when mode="currency"
  locale, // for formatting
  showButtons = true,
  buttonLayout = "stacked",
}: NumberInputFieldProps) => {
  return (
    <div className={containerClassName}>
      <InputLabel
        name={name}
        label={label}
        required={required}
        errorMessage={errorMessage}
      />
      <InputNumber
        id={name}
        name={name}
        value={value}
        onValueChange={(e) => onChange(e)}
        className={inputClassName}
        required={required}
        min={min}
        max={max}
        step={step}
        minFractionDigits={minFractionDigits}
        maxFractionDigits={maxFractionDigits}
        prefix={prefix}
        suffix={suffix}
        mode={mode}
        currency={currency}
        locale={locale}
        placeholder={placeholder}
        disabled={disabled}
        showButtons={showButtons}
        buttonLayout={buttonLayout}
        incrementButtonClassName="p-button-secondary"
        decrementButtonClassName="p-button-secondary"
      />
    </div>
  );
};

export default NumberInputField;
